import { LocationDescriptorObject } from "history";
import { getRouteHrefById } from "../../routing";
import { CommonRouteId } from "../routes";


export const makeFrontPageHref = (): LocationDescriptorObject => ({
    pathname: getRouteHrefById(CommonRouteId.CommonFrontPage),
});


export const makeLoginExpiredPageHref = (prevPath?: string): LocationDescriptorObject => ({
    pathname: getRouteHrefById(CommonRouteId.LoginExpiredPage),
    state: { prevPath }
});



